import type { Feature } from './feature'

export class Selectors {
  public readonly pulse
  public readonly selectedDate
  public readonly teamSpirit
  public readonly teamMembersOverview
  public readonly isLoading
  public readonly engagementBreakdown

  constructor(feature: Feature) {
    this.pulse = feature.state.project(state => state.pulse)
    this.selectedDate = feature.state.project(state => state.fromDate)
    this.teamSpirit = this.pulse.project(pulse => pulse?.data?.teamSpirit)
    this.teamMembersOverview = this.pulse.project(
      pulse => pulse?.data?.teamMembersOverview,
    )
    this.engagementBreakdown = this.pulse.project(
      pulse => pulse?.data?.engagementBreakdown,
    )
    this.isLoading = feature.state.project(state => state.pulse?.loading)
  }
}
